import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import TwoFactorSection from "../components/settings/TwoFactorSection";

export default function SettingsSecurity() {
  const { t } = useTranslation("common");
  return (
    <div className="animate-fade-up" data-testid="settings-security-page">
      <div className="mb-8">
        <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-2 inline-flex items-center gap-1.5">
          <ShieldCheck size={12} strokeWidth={1.75} />
          {t("settings.security.nav_label")}
        </p>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-950">
          {t("settings.security.title")}
        </h1>
        <p className="text-sm text-zinc-500 mt-1.5 max-w-xl">{t("settings.security.subtitle")}</p>
      </div>
      <TwoFactorSection />
    </div>
  );
}
